const SupplierInfoView = ({
  product,
  hasBomProductsNotInOdoo,
  prices,
  computedCost,
}) => {
  if (!hasBomProductsNotInOdoo && prices.length === 0) {
    return <div className="opacity-70">No Price Info.</div>;
  }

  return (
    <div className="-mx-2">
      <table className="with-line whitespace-nowrap">
        <thead>
          <tr>
            <th>Company</th>
            <th>Vendor</th>
            <th className="text-right">Qty</th>
            <th className="text-right">Price</th>
          </tr>
        </thead>
        <tbody>
          {hasBomProductsNotInOdoo ? (
            <tr>
              <td>
                {product.defaultSupplier ? product.defaultSupplier.name : " - "}
              </td>
              <td>{product.defaultQty}</td>
              <td>{computedCost}</td>
            </tr>
          ) : (
            prices.map((i) => (
              <tr key={i.id}>
                <td>{i.company}</td>
                <td>{i.factory ? i.factory.name : "-"}</td>
                <td className="text-right">{i.minQty}</td>
                <td className="text-right">
                  {i.currency} {i.price}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SupplierInfoView;
